import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

import ParticipantIcon from '../../../icons/ParticipantIcon';

import useChatContext from '../../../hooks/useChatContext/useChatContext';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import useParticipants from '../../../hooks/useParticipants/useParticipants';
import useParticipantWindowContext from '../../../hooks/useParticipantWindowContext/useParticipantWindowContext';

export const ANIMATION_DURATION = 700;

const IconContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'activeChat',
})<{ activeChat?: boolean }>(({ activeChat }) => ({
  position: 'relative',
  display: 'flex',
  ...(activeChat && {
    '& svg': {
      filter: 'invert(27%) sepia(11%) saturate(2879%) hue-rotate(80deg) brightness(98%) contrast(100%)',
    },
  }),
}));

export default function ToggleParticipantButton() {
  const [shouldAnimate, setShouldAnimate] = useState(false);

  const { setIsChatWindowOpen } = useChatContext();
  const { setIsBackgroundSelectionOpen } = useVideoContext();
  const participants = useParticipants();
  const { isParticipantWindowOpen, setIsParticipantWindowOpen } = useParticipantWindowContext();

  const toggleParticipantWindow = () => {
    setIsParticipantWindowOpen(!isParticipantWindowOpen);
    setIsChatWindowOpen(false);
    setIsBackgroundSelectionOpen(false);
  };

  useEffect(() => {
    if (shouldAnimate) {
      setTimeout(() => setShouldAnimate(false), ANIMATION_DURATION);
    }
  }, [shouldAnimate]);

  if (participants.length === 0) return null;

  return (
    <Tooltip
      title="Participants"
      placement="top"
      PopperProps={{ disablePortal: true }}
      style={{ cursor: participants.length === 0 ? 'not-allowed' : 'pointer' }}
    >
      <span>
        <Button
          data-cy-participants-button
          onClick={toggleParticipantWindow}
          disabled={participants.length === 0}
          startIcon={
            <IconContainer activeChat={isParticipantWindowOpen}>
              <ParticipantIcon />
            </IconContainer>
          }
        >
          {/* Participants */}
        </Button>

      </span>
    </Tooltip>
  );
}
